import { Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SelectedTrip from "./Selected Trip/SelectedTrip";
import { retrieveFromLocalStorage } from "../../../Common/Utils";

export default function SelectedFlight(props) {
  const flight = useSelector((state) => state.flight.selectedFlight);
  //const journeyDetails = useSelector((state) => state.flight.journeyDetails);
  const [departure, setDeparture] = useState([]);
  const [freturn, setReturn] = useState([]);
  useEffect(() => {
    if (flight && flight?.slices) {
      let ret = [];
      let dep = [];
      flight.slices.map((item) => {
        let slicedDataDep = { ...item, segments: [] };
        let slicedDataRet = { ...item, segments: [] };
        item.segments.map((seg) => {
          if (seg.return === 1) {
            slicedDataRet.segments.push(seg);
          } else {
            slicedDataDep.segments.push(seg);
          }
        });
        if (slicedDataDep.segments.length > 0) {
          dep.push(slicedDataDep);
        }
        if (slicedDataRet.segments.length > 0) {
          ret.push(slicedDataRet);
        }
      });

      setDeparture(dep);
      setReturn(ret);
    }
  }, [flight]);
  return (
    <>
      <Typography
        variant="h6"
        align="left"
        style={{ backgroundColor: "white", padding: "0.75rem 1.5rem" }}
      >
        Trip Summary
      </Typography>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {departure &&
          departure.length > 0 &&
          departure[0]?.segments.length > 0 &&
          departure.map((airport, i) => (
            <SelectedTrip
              airport={airport}
              baggage={
                flight?.baglimit ? flight?.baglimit : flight?.baggage_info
              }
              tripType={"Depart"}
            />
          ))}

        {freturn &&
          freturn.length > 0 &&
          freturn[0]?.segments.length > 0 &&
          freturn.map((airport, i) => (
            <SelectedTrip
              airport={airport}
              baggage={
                flight?.baglimit ? flight?.baglimit : flight?.baggage_info
              }
              tripType={"Return"}
            />
          ))}
      </div>
    </>
  );
}
